// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "assets_3.15.0/js/[name].bundle" + "-" + "15d887034d5f236428dc" + "-bundle.js";
};